import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import Select from 'react-select';
import ReactDOM from 'react-dom';
import { estructuraOrdenTrabajo } from "../../utils/estructuras";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRectangleXmark } from "@fortawesome/free-solid-svg-icons";

// Alertas
import Swal from 'sweetalert2'

import TareaContext from '../../context/tareaContext/tareaContex';

import {addToDate, getDifferenceInDays} from '../../utils/funciones'
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import MANTENIMIENTO from '../../images/MANTENIMIENTO.png';
import QRCode from "react-qr-code";


const ModalFormDownloadQRs = ({usuario, minimizar, activoSelected, activoList, nivel1Lista}) =>{

    const [activosSelected,setActivosSelected] = useState([activoSelected]);

    const refQr = useRef(null);

    const activosOptions = useMemo(()=>{
        if(activoList && activoList.length > 0) return activoList.map(a => ({label: a.name, value: a.codActivo}));
        else return []
    },[activoList]);

    const areasOptions = useMemo(()=>{
        if(nivel1Lista && nivel1Lista.length > 0) return nivel1Lista.map(a => ({label: a.name, value: a._id}));
        else return [];
    },[nivel1Lista])

    const handleChange = (value) => {
        setActivosSelected(value);
    }

    const handlePrint = async () => {
        Swal.fire("Se descargará un solo archivo PDF con todos los QR seleccionados")
        const pdf = new jsPDF();
        const container = refQr.current;

        if(!container) return;

        for(let i = 0; i < activosSelected.length; i++){
            const activo = activosSelected[i];

            const qrElement = <QRCode value={activo.value} size={128}/>;

            ReactDOM.render(qrElement, container);

            await new Promise((res) => setTimeout(res,100));

            const canvas = await html2canvas(container);
            const qrImage = canvas.toDataURL('image/png');

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const qrX = (pdfWidth - 80) / 2;

            const text = `${activo.label} - ${activo.value}`;
            const textWidth = pdf.getTextWidth(text);
            const textX = (pdfWidth - textWidth) / 2;
            
            const text2 = `${activo.label} - ${activo.value}`;
            const text2Width = pdf.getTextWidth(text2);

            const pdfHeight = pdf.internal.pageSize.getHeight();
            const bottomMargin = 20;

            const text2Y = pdfHeight - bottomMargin;

            const imageX = (pdfWidth - 150) / 2;
            pdf.addImage(MANTENIMIENTO,'PNG',imageX, 20,150,30)
            

            pdf.text(text, textX, 100);
            pdf.addImage(qrImage, 'PNG', qrX, 110 ,80, 80);
            pdf.text('https://www.xertux.com/', textX, text2Y);

            if(i < activosSelected.length - 1) pdf.addPage();
        }

        pdf.save('QRCodes.pdf');
    }

    const handleChangeFacilitatorNivel1 = async (value) => {
        let activosFiltered = activoList.filter(a => a.activoNivel1ID == value.value);
        activosFiltered = activosFiltered.map(a => ({label: a.name, value: a.codActivo}));
        activosFiltered = activosFiltered.filter(a => !activosSelected.some(ac => a.value == ac.value));
        setActivosSelected([...activosSelected, ...activosFiltered]);        
    }

    return <div className="modalFormDiv modalFormDownloadQRs">
         <button className="minimizarBtn" onClick={minimizar}>X</button>
         
         <div className="headerModalForm">Impresión de códigos QR en lote</div>
         <div className="bodyModalForm bodyModalFormDownloadQRs">
            <div className="facilitatorGetByNivel1Div">
                <label>Recuperar desde Área</label>
                <Select 
                    styles={{
                        container: base => ({
                            ...base,
                            width:'50%',
                        }),
                    }}
                    value={{}}
                    options={areasOptions}
                    onChange={(value)=>handleChangeFacilitatorNivel1(value)}
                />
            </div>
            <Select
                styles={{
                    container: base => ({
                        ...base,
                        width:'80%',
                    }),
                    multiValueLabel: (base) => ({
                    ...base,
                    boxShadow:"none",
                    backgroundColor: "#6b9080",
                    color: 'white',
                    borderRadius: "none",
                    fontSize: "1rem"
                    }), 
                    multiValueRemove: (base) => ({
                        ...base,
                        backgroundColor: "#6b9080",
                        color: 'white',
                        borderRadius: "none",
                        fontSize: "1rem"
                    }),
                }}
                isMulti
                placeholder=""
                options={activosOptions}
                value={activosSelected}
                onChange={(value)=>handleChange(value)}
            />
         </div>
        <div ref={refQr} className="invisibleQRContainerRef">
        </div>
        <button className="btn" onClick={handlePrint}>IMPRIMIR</button>
    </div>

}

export default ModalFormDownloadQRs;